import { DEFAULT_LANGUAGE } from '../constants/constants';
import { TodoStatusCode } from '../constants/todo';
import { Todo } from '../types/databaseTypes';

// 두 배열이 같은 내용을 가지고 있는지 비교하는 헬퍼 함수
export const arraysEqual = <T>(
    a: T[],
    b: T[],
    comparator?: (a: T, b: T) => boolean
): boolean => {
    if (a.length !== b.length) return false;

    // 숫자 배열인 경우 정렬 후 비교
    if (a.length > 0 && typeof a[0] === 'number') {
        const aCopy = [...a] as number[];
        const bCopy = [...b] as number[];
        aCopy.sort((x, y) => x - y);
        bCopy.sort((x, y) => x - y);
        return aCopy.every((val, idx) => val === bCopy[idx]);
    }

    // 사용자 정의 비교 함수가 있으면 사용
    if (comparator) {
        return a.every((val, idx) => comparator(val, b[idx]));
    }

    // 기본 비교 (순서 중요)
    return a.every((val, idx) => val === b[idx]);
};

// Todo의 상태를 확인하는 헬퍼 함수
export const getTodoStatus = (todo: Todo) => {
    if (todo.cancelled_date !== null) {
        return TodoStatusCode.CANCELLED;
    }
    if (todo.complete_date !== null) {
        return TodoStatusCode.COMPLETED;
    }
    return TodoStatusCode.IN_PROGRESS;
};

/**
 * 브라우저 타임존 감지 함수
 */
export const detectBrowserTimezone = (): string => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

/**
 * 브라우저 언어 감지 함수
 * @returns 'ko-KR', 'en-US', 'vi-VN' 형식의 언어 코드
 */
export const detectBrowserLanguage = (): string => {
    // 로컬스토리지 먼저 체크
    let language = localStorage.getItem('i18nextLng');
    if (!language) {
        // 없으면 브라우저 언어로 설정
        language = navigator.language; // 'ko', 'en-US', 'vi' 등
    }

    // 이미 지역 정보가 있는 경우
    if (language.includes('-')) {
        return language;
    }

    // 지역 정보 추가
    switch (language) {
        case 'ko':
            return 'ko-KR';
        case 'en':
            return 'en-US';
        case 'vi':
            return 'vi-VN';
        default:
            return DEFAULT_LANGUAGE;
    }
};

/**
 * 사용자의 운영체제(OS) 타입을 감지합니다
 * @returns 'ios', 'android', 또는 'other' 중 하나
 */
// export const detectMobileOS = (): 'ios' | 'android' | 'other' => {
//     const userAgent = navigator.userAgent;
//     // || navigator.vendor || (window as any).opera;

//     // iOS 감지
//     // MSStream은 IE/Edge에서 사용하는 속성으로, TypeScript에 정의되어 있지 않아 as unknown 필요
//     if (
//         /iPad|iPhone|iPod/.test(userAgent) &&
//         !(window as unknown as { MSStream: unknown }).MSStream
//     ) {
//         return 'ios';
//     }

//     // Android 감지
//     if (/android/i.test(userAgent)) {
//         return 'android';
//     }

//     // 그 외 PC나 기타 기기
//     return 'other';
// };

/**
 * 모바일 앱 스토어 링크를 가져옵니다
 * @returns 현재 기기에 알맞은 앱 스토어 URL
 */
// export const getAppStoreLink = (): string => {
//     const appStoreId = APP_STORE_ID;
//     const playStoreId = PLAY_STORE_ID;
//     const os = detectMobileOS();

//     switch (os) {
//         case 'ios':
//             return `https://apps.apple.com/app/id${appStoreId}`;
//         case 'android':
//             return `https://play.google.com/store/apps/details?id=${playStoreId}`;
//         default:
//             // PC 등 기타 환경일 경우 웹사이트로
//             return '/';
//     }
// };
